import React from 'react';
import OverlayController from "../components/overlay/OverlayController";
import CircularProgress from "material-ui/CircularProgress";
import Dialog from '../components/overlay/Dialog';
import utils from "./utils";

export default function() {

    OverlayController.showActivityIndicator = function() {
        OverlayController.showOverlay({
            hideOnCurtainClick: false,
            hideOnEscape: false,
            component: <CircularProgress color="white" size={50} thickness={5} />
        });
    };

    OverlayController.hideActivityIndicator = function() {
        OverlayController.hideOverlay();
    };

    OverlayController.showErrorAlert = function(error) {
        let actions = [{label: "Ok", handler: () => OverlayController.hideOverlay()}];
        let title = "Error";
        let errorMessage = utils.errorOrGraphQLMessage(error);
        OverlayController.showOverlay({
            component: (
                <Dialog title={title} actions={actions} className="error-dialog">
                    <div>{errorMessage}</div>
                </Dialog>
            )
        });
    };

}



// WEBPACK FOOTER //
// ./src/utils/extendOverlayController.js